













































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { UtteranceViewModel } from '@/features/bots/models/intents/utteranceViewModel';
import shortid from 'shortid';

@Component({
	components: {
	}
})
export default class UtteranceList extends Vue {
	@Prop() public value: UtteranceViewModel[];
	@Prop() public v: any;
	@Prop({default: 'utterance'}) public term: string;
	@Prop({default: false}) public isEditable: boolean;

	public utterances: UtteranceViewModel[] = [];

	@Watch('value', { immediate: false })
	public onValueChanged(value: UtteranceViewModel[]) {
		this.utterances = value;
	}

	public mounted() {
		if (this.v && this.v.$reset) {
			this.v.$reset();
		}
		this.utterances = this.value;
		if (this.utterances.length === 0) {
			this.addUtterance();
		}
	}

	public addUtterance() {
		const utteranceId = shortid.generate();
		this.utterances.push({
			id: utteranceId,
			text: ''
		});

		this.$emit('input', this.utterances);
		this.focusOnUtterance(utteranceId);
	}

	public deleteUtterance(id: string) {
		this.v.$touch();
		this.utterances = this.utterances.filter(u => u.id !== id);
		this.$emit('input', this.utterances);
	}

	public utteranceChanged() {
		this.$emit('input', this.utterances);
	}

	public moveToNextUtterance(fromUtteranceId: string) {
		const currentIndex = this.utterances.findIndex(u => u.id === fromUtteranceId);
		const nextIndex = currentIndex + 1;
		if (nextIndex >= this.utterances.length) {
			this.addUtterance();
		} else {
			const nextUtteranceId = this.utterances[nextIndex].id;
			this.focusOnUtterance(nextUtteranceId);
		}
	}

	public getPlaceholderText() {
		return `Enter your ${this.term}`;
	}

	private focusOnUtterance(utteranceId: string) {
		this.$nextTick(() => {
			const refId = 'input-' + utteranceId;
			const inputField = (this.$refs[refId] as HTMLElement[]);
			if (inputField) {
				inputField[0].focus();
			}
		});
	}
}

